import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import { LoadingScreen } from 'src/components/loading-screen';
const VoicemailSetup = lazy(() => import('src/pages/voicemail-setup/index'));

export const VoicemailSetupRoutes = [
  {
    path: 'answering-machine-setup',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [{ element: <VoicemailSetup />, path: '' }],
  },
];
